__turbopack_context__.v({
  "container": "EditorBox-module-scss-module__CBej2G__container",
  "editorToolbar": "EditorBox-module-scss-module__CBej2G__editorToolbar",
});
